export default {
  path: 'fleet',
  name: 'fleet',
};
